var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklists(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.005,
    height: 16.359,
    viewBox: "0 0 15.005 16.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_live_help_24px",
    d: "M16.338,2H4.667A1.615,1.615,0,0,0,3,3.558V14.464a1.615,1.615,0,0,0,1.667,1.558H8l2.5,2.337L13,16.022h3.334a1.62,1.62,0,0,0,1.667-1.558V3.558A1.62,1.62,0,0,0,16.338,2Zm-5,12.464H9.669V12.906h1.667Zm1.726-6.037-.75.717a2.576,2.576,0,0,0-.975,2.2H9.669v-.39a3.036,3.036,0,0,1,.975-2.2l1.034-.982a1.476,1.476,0,0,0,.492-1.1,1.671,1.671,0,0,0-3.334,0H7.168A3.23,3.23,0,0,1,10.5,3.558a3.23,3.23,0,0,1,3.334,3.116A2.4,2.4,0,0,1,13.062,8.427Z",
    transform: "translate(-3 -2)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklists);
export default __webpack_public_path__ + "static/media/Checklists.446c9ce066500f98635b40cf8ed1fb05.svg";
export { ForwardRef as ReactComponent };